// Hub FAQ answers built only from the schedule rows already on file for a hub.
// Used by the hub page and the prerender. Never adds rooms, days, or buy-ins.
function realRows(room) {
  return (room.schedules || []).filter(function(row) {
    return row && row.day && row.start && row.buyin;
  });
}

function buyinAmount(text) {
  var m = String(text || '').replace(/,/g, '').match(/\$\s*(\d+(?:\.\d+)?)/);
  return m ? parseFloat(m[1]) : null;
}

function startMinutes(text) {
  var m = String(text || '').match(/(\d{1,2})(?::(\d{2}))?\s*([ap])/i);
  if (!m) return null;
  var h = parseInt(m[1], 10) % 12;
  if (m[3].toLowerCase() === 'p') h += 12;
  return h * 60 + (m[2] ? parseInt(m[2], 10) : 0);
}

function runsOnWeekend(day) {
  return /daily|saturday|sunday|weekend/i.test(String(day || ''));
}

function listNames(names) {
  if (names.length <= 1) return names.join('');
  if (names.length === 2) return names[0] + ' and ' + names[1];
  return names.slice(0, -1).join(', ') + ', and ' + names[names.length - 1];
}

function buildHubFaq(hub) {
  var area = hub.shortLabel || hub.footerLabel || 'this area';
  var inArea = /area$/i.test(area) || area === 'Central Valley' || area === 'Central Coast' ? 'the ' + area : area;
  inArea = inArea.replace(' & ', ' and ');
  var rooms = hub.rooms || [];
  var withRows = rooms.filter(function(room) { return realRows(room).length; });
  if (!withRows.length) return [];
  var items = [];

  items.push({
    q: 'How many ' + area + ' poker rooms have tournament schedules on Daily Tourneys?',
    a: withRows.length + ' of the ' + rooms.length + ' ' + area + ' rooms listed here have a daily or weekly schedule with day, start time, and buy-in on file: ' +
      listNames(withRows.map(function(room) { return room.name; })) + '.'
  });

  var byCity = {};
  var cityOrder = [];
  withRows.forEach(function(room) {
    var city = room.city || '';
    if (!city) return;
    if (!byCity[city]) { byCity[city] = []; cityOrder.push(city); }
    byCity[city].push(room.name);
  });
  if (cityOrder.length) {
    var nearArea = area.replace(/ area$/i, '').replace(' & ', ' and ');
    items.push({
      q: 'Where can I play poker tournaments near ' + nearArea + '?',
      a: 'Rooms with tournament schedules on file near ' + nearArea + ': ' +
        cityOrder.map(function(city) { return city + ' (' + byCity[city].join('; ') + ')'; }).join(', ') +
        '. Open a room for its days, start times, and buy-ins.'
    });
  }

  var cheapest = [];
  withRows.forEach(function(room) {
    var best = null;
    realRows(room).forEach(function(row) {
      var amt = buyinAmount(row.buyin);
      if (amt === null || amt <= 0) return;
      if (!best || amt < best.amt) best = { amt: amt, row: row };
    });
    if (best) cheapest.push({ room: room.name, amt: best.amt, row: best.row });
  });
  cheapest.sort(function(a, b) { return a.amt - b.amt || a.room.localeCompare(b.room); });
  if (cheapest.length) {
    var top = cheapest.slice(0, 3).map(function(c) {
      return c.row.buyin + ' at ' + c.room + ' (' + c.row.day + ' ' + c.row.start + ')';
    });
    items.push({
      q: 'What are the lowest tournament buy-ins in ' + inArea + '?',
      a: 'The lowest buy-ins on file are ' + listNames(top) + '. Rake, re-entries, and add-ons can change the total cost, so check the event details before you go.'
    });
  }

  var freerolls = withRows.filter(function(room) {
    return realRows(room).some(function(row) { return buyinAmount(row.buyin) === 0; });
  }).map(function(room) { return room.name; });
  if (freerolls.length) {
    items.push({
      q: 'Are there freeroll tournaments in ' + inArea + '?',
      a: 'Yes. ' + listNames(freerolls) + (freerolls.length === 1 ? ' lists' : ' list') + ' at least one $0 buy-in event on its schedule. Freerolls often need a membership, points, or a qualifying session, so ask the room how to get a seat.'
    });
  }

  var weekend = withRows.filter(function(room) {
    return realRows(room).some(function(row) { return runsOnWeekend(row.day); });
  }).map(function(room) { return room.name; });
  if (weekend.length) {
    items.push({
      q: 'Which ' + area + ' rooms run tournaments on weekends?',
      a: listNames(weekend) + (weekend.length === 1 ? ' has' : ' have') + ' Saturday, Sunday, or daily events on file.'
    });
  }

  var early = withRows.filter(function(room) {
    return realRows(room).some(function(row) {
      var mins = startMinutes(row.start);
      return mins !== null && mins < 14 * 60;
    });
  }).map(function(room) { return room.name; });
  if (early.length) {
    items.push({
      q: 'Are there morning or early-afternoon tournaments in ' + inArea + '?',
      a: listNames(early) + (early.length === 1 ? ' has' : ' have') + ' at least one event starting before 2pm.'
    });
  }

  items.push({
    q: 'How current are these ' + area + ' tournament schedules?',
    a: 'Schedules are compiled from public calendars and flyers the rooms post. Rooms change start times for holidays and series, so confirm the day\u2019s start time and late registration with the room before you drive over. Spot a mistake? Email info@dailytourneys.com.'
  });
  return items;
}

module.exports = buildHubFaq;



// WEBPACK FOOTER //
// ./js/hub-faq.js